/* file description */
import { Select, message, Divider, Button, Space } from 'antd';
import React, { FC, useState, useEffect, useCallback } from 'react';
import { useGetTreeData, useSetVal, useGetBindLabel } from './effect';
import { COLUMN_FROM } from '../../effects/consts';
import _ from 'lodash';
import copy from 'copy-to-clipboard';
import { CopyOutlined, PlusOutlined } from '@ant-design/icons';
import { Picker, Toast } from 'antd-mobile';
import { CustomSelectProps } from './type';
import { MobileSelect } from '../MobileSelect';
import styles from './index.module.less';
import memo from '../memo';

export const CustomSelect: FC<CustomSelectProps> = ({
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  disabled,
  API,
  storeValue,
  rowsData,
  isMobile,
  allowClear,
  moduleInfo,
}) => {
  const [status, setStatus] = useState<any>('');
  const [copyIcon, setCopyIcon] = useState<boolean>(false);
  const { bindData } = useGetBindLabel({ field, API, form, config, columnFrom, moduleInfo, onChange });
  const { treeData } = useGetTreeData({ field, form, config, columnFrom, API, onChange, fieldValue: value, storeValue, rowsData, moduleInfo });
  const { selectTree } = useSetVal({ onChange, field, columnFrom, form, treeData, config, moduleInfo });

  // let fieldError: any[];
  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   const tableValid = form.getFieldsError().find((item: any) => item.name[0] === config.rowIndex && item.name[1] === field.name);
  //   fieldError = tableValid?.errors || [];
  // } else {
  //   fieldError = form.getFieldError(field.name);
  // }

  const optionsData = field?.options?.isBindLabel ? bindData : treeData;

  // useEffect(() => {
  //   if (fieldError?.length > 0) {
  //     setStatus('error');
  //   } else {
  //     setStatus('');
  //   }
  // }, [fieldError]);

  useEffect(() => {
    if (optionsData?.length === 1 && !field?.options?.isMulti && value !== optionsData[0].value) {
      if (config.from !== 'search') {
        selectTree(optionsData[0].value);
      }
    }
  }, [optionsData]);

  useEffect(() => {
    if (value) {
      selectTree(value, false);
    }
  }, [value]);

  const getMultiValue = (val: any) => {
    if (field?.options?.isMulti) {
      if (_.isArray(val)) {
        return val;
      } else {
        const arrVal = val ? val?.split(',') : [];
        return arrVal;
      }
    } else {
      return val;
    }
  };

  const options = field?.options?.isBindLabel ? bindData : treeData;

  /**
   * @isMobile 是否是移动端
   * @options.length  如果下拉条数为10一下开启pick
   * @!field?.options?.isMulti  不是多选才能触发
   * TODO: 清除功能、模型多选
   */
  if (isMobile) {
    return (
      <MobileSelect
        value={getMultiValue(value)}
        options={options}
        onChange={selectTree}
        disabled={disabled}
        mode={field?.options?.isMulti ? 'multiple' : undefined}
      />
    );
  }

  const copyName = () => {
    const findDict = options.find((item: any) => item.value === value) || {};
    copy(findDict?.label || value);
    message.success('复制成功');
  };


  return (
    <>
      <Select
        style={{ width: '100%', minWidth: '100px' }}
        status={status}
        allowClear={allowClear !== false}
        showSearch
        showArrow
        mode={field?.options?.isMulti ? 'multiple' : undefined}
        value={getMultiValue(value)}
        options={options}
        onChange={selectTree}
        disabled={disabled}
        onMouseEnter={() => {
          if (value) {
            setCopyIcon(true);
          }
        }}
        onMouseLeave={() => setCopyIcon(false)}
        filterOption={(inputvalue, option) => {
          // label过滤
          if (option?.label.includes(inputvalue)) {
            return true;
          }
          // 拼音首字母过滤
          if (option?.firstPY.includes(inputvalue.toLowerCase())) {
            return true;
          }
          // 拼音过滤
          if (option?.fullPY.includes(inputvalue.toLowerCase())) {
            return true;
          }
          return false;
        }}
        dropdownRender={(menu) => (
          <>
            {menu}
            {
              field?.options?.canAdd ?
                <>
                  <Divider style={{ margin: '8px 0' }} />
                  <Space style={{ padding: '0 8px 4px' }}>
                    <Button
                      size="small"
                      type="text"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        const a = document.createElement('a');
                        a.setAttribute('href', field?.options?.addPageId);
                        a.setAttribute('target', '_blank');
                        a.setAttribute('id', 'LINKMODALHREF');
                        // 防止反复添加
                        if (document.getElementById('LINKMODALHREF')) {
                          document.body.removeChild(document.getElementById('LINKMODALHREF') as any);
                        }
                        document.body.appendChild(a);
                        a.click();
                      }}
                    >
                      新增
                    </Button>
                  </Space>
                </> : ''
            }
          </>
        )}
      // optionFilterProp="label"
      />
      {
        copyIcon ?
          <div
            onMouseEnter={() => setCopyIcon(true)}
            className={styles.select_copy_icon}
            onClick={copyName}
          >
            <CopyOutlined style={{ color: '#999999' }} />
          </div> : ''
      }
    </>
  );
};

export default memo(CustomSelect);
// export default React.memo(CustomSelect, (prevProps, nextProps) => {
//   if (prevProps.value !== nextProps.value || prevProps.disabled !== nextProps.disabled) {
//     return false;
//   }
//   // 暂时只支持 parentField字段的判定刷新
//   const parentField = prevProps.field?.bizConfig?.parentField;
//   const handle = prevProps.moduleInfo?.handle;
//   if (parentField && handle) {
//     const prevValue = _.get(prevProps.storeValue, [handle, parentField]);
//     const nextValue = _.get(nextProps.storeValue, [handle, parentField]);
//     if (prevValue !== nextValue) {
//       return false;
//     }
//   }
//   return true;
// });
